// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"ac354f6a","133":"43d46871","442":"ac354f6a"}[chunkId] + ".chunk.css";
};